import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.dataDetailForm.loading;
export const selectErrorMessage = (state: RootState) =>
  state.dataDetailForm.error;
export const dataDetailFormResponse = (state: RootState) =>
  state.dataDetailForm.dataDetailFormResponse;
